module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_15-9f4735c8969dbeee0236916ffbfe0923.png";